module.exports = __webpack_public_path__ + "static/img/20006 (1).cefe5dc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20006 (1).webp
// module id = ucFw
// module chunks = 14